import { DateTimePicker, type DateTimePickerProps } from "@mui/x-date-pickers";

type UTCDateTimePickerProps = Omit<
  DateTimePickerProps<boolean>,
  "value" | "onChange" | "timezone"
> & {
  value: Date | null | undefined;
  onChange: (value: Date | null) => void;
};

// NOTE Timezone handling should ideally be a part of the `LocalizationProvider`, but
// since this would require a big refactor of the localization logic.
// Also the current `AdapterDateFns` does not support UTC timezone.
// This wrapper is the most pragmatic solution. Effort should be made to
// refactor this in the future.
export function UTCDateTimePicker({
  value,
  onChange,
  ...rest
}: UTCDateTimePickerProps) {
  const localValue = value
    ? new Date(
        value.getUTCFullYear(),
        value.getUTCMonth(),
        value.getUTCDate(),
        value.getUTCHours(),
        value.getUTCMinutes(),
        value.getUTCSeconds(),
        value.getUTCMilliseconds(),
      )
    : null;

  const handleChange = (newValue: Date | null) => {
    if (!newValue) {
      onChange(null);
      return;
    }

    const utcDate = new Date(
      Date.UTC(
        newValue.getFullYear(),
        newValue.getMonth(),
        newValue.getDate(),
        newValue.getHours(),
        newValue.getMinutes(),
        newValue.getSeconds(),
        newValue.getMilliseconds(),
      ),
    );
    onChange(utcDate);
  };

  return (
    <DateTimePicker
      value={localValue}
      onChange={handleChange}
      timezone="UTC"
      {...rest}
    />
  );
}
